<template>
  <div>
    <MainTitle
      title="劳务用工"
      path="/labour"
      :titleImg="require('@/assets/fourf.png')"
    />
    <div class="content">
      <div v-if="loading">
        <el-row :gutter="20">
          <el-col :span="12" :key="index" v-for="(item, index) in 6" style="">
            <el-skeleton style="width: 100%">
              <template slot="template">
                <div
                  style="
                    margin: 10px 5px;
                    padding: 10px;
                    border: 1px solid #e4e7ed;
                  "
                >
                  <div style="background: #f5f7fa; line-height: 40px">
                    <el-skeleton-item variant="text" style="width: 300px" />
                  </div>
                  <el-skeleton-item variant="text" style="width: 150px" />
                  <el-row :gutter="20">
                    <el-col :span="12" class="item_text single_hide">
                      <el-skeleton-item variant="text" style="width: 150px" />
                    </el-col>
                    <el-col :span="12" class="item_text single_hide">
                      <el-skeleton-item variant="text" style="width: 150px" />
                    </el-col>
                    <el-col :span="12" class="item_text single_hide">
                      <el-skeleton-item variant="text" style="width: 150px" />
                    </el-col>
                    <el-col :span="12" class="item_text single_hide">
                      <el-skeleton-item variant="text" style="width: 150px" />
                    </el-col>
                  </el-row>
                  <el-skeleton-item variant="text" style="width: 300px" />
                </div>
              </template>
            </el-skeleton>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row :gutter="20">
          <el-col :span="12" v-for="(item, index) in list" :key="index">
            <card :item="item" :type="6"></card>
          </el-col>
        </el-row>
        <paging
          :sq="this.param.page > 1"
          :gd="list.length < this.param.total"
          @pageupdata="pageupdata"
        ></paging>
      </div>
      <!-- 无数据 -->
      <BaseEmptyData v-if="!list.length && !loading"></BaseEmptyData>
    </div>
  </div>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import { apiFlexibleEmployment } from "@/api/apiFlexibleEmployment"
import cookie from "@/storage/cookies"
import { mapState } from "vuex"

export default {
  name: "labour",
  components: {
    MainTitle: () => import("@/views/Home/AllComponents/MainTitle"), // 头部组件
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 无数据组件
    paging: () => import("./paging"), // 分页组件
    card: () => import("@/components/card/cardLabor.vue") // 劳务用工card
  },
  data() {
    return {
      type: "0",
      list: [],
      param: {
        page: 1,
        limit: 6,
        total: 0,
        sortType: 1,
        distanceSortType: 1,
        timeSortType: 1,
        areaNo: [],
        cityNo: ""
      },
      code: {},
      loading: true
    }
  },
  created() {
    this.tabSelect({ type: "0" })
  },
  computed: {
    //获取坐标经纬度
    ...mapState({
      position: state => state.position
    })
  },
  methods: {
    pageupdata(v) {
      if (v) this.param.page = v
      else this.param.page++
      this.getlist()
    },
    tabSelect(v) {
      this.type = v.type
      this.param.latitude = this.position.lat //纬度
      this.param.longitude = this.position.lng //经度
      //参数封装
      let code = {}
      let cookieArea = cookie.cookieRead("area")
      let area = cookieArea ? JSON.parse(cookieArea) : null
      if (area) code.provinceNo = area.id
      this.func = apiFlexibleEmployment.laborEmploymentList
      //参数重置
      this.code = code
      this.param.page = 1
      this.getlist()
    },
    //获取数据列表
    async getlist() {
      if (this.param.page == 1) {
        this.list = []
        this.param.total = 0
      }
      this.loading = true
      let param = { ...this.param, ...this.code }
      if (this.type == 3) {
        param.pageNum = param.page
        param.pageSize = param.limit
      }
      console.log(param, "99999999999")
      let res = await this.func(param)
      if (res.data && res.data.code === 200) {
        this.loading = false
        if (this.param.page == 1) this.list = res.data.data.records
        else this.list = this.list.concat(res.data.data.records)
        this.param.total = res.data.data.total
      }
    },
    getList() {
      this.pageupdata(1)
      this.$emit("changeHash", "box4")
    }
  },
  provide() {
    return {
      cardListCom: this
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 1200px;
  min-height: 200px;
  padding: 0 20px;
  background: #fff;
  box-sizing: border-box;
  margin: auto;
  /deep/.empty-data {
    padding: 0 0 20px;
  }
}
</style>
